import Service from "../service";
const url = 'pregnant/form3'
const Pregnant3 ={
    saveForm(data){
        return Service.post(url,data);
    },
    show(id){
        return Service.get(`${url}`,{
            params:{
                form_id:id
            }
        });
    },
}
export default Pregnant3